module.exports = __webpack_public_path__ + "media/assets/community/logo-mb-a616c5011db49e357a8d963cd93f920b10da28da42a9879df20295ac23965dfe.png";